export default {
  language: {
    en: {
      menu: {
        top: 'Top',
        overview: 'Overview',
        members: 'Members',
        contact: 'Contact'
      },
      footer: {
        name: 'Hoge.class mission',
        mission: '私たちはマインクラフトが大好きです。そして、このゲームをもっと多くの方々に楽しんでもらいたいと思っています。<br>' +
        'マインクラフトはただ遊ぶだけではなく、マイクラファンが開発する拡張機能を使えばプログラミングによって、自由に遊びを創造することができます。' +
        '多人数で遊びたいと思い、まともマルチサーバを建てると、ネットワークの知識を得ることができます。<br>' +
        '今日、子供のIT教育にもマインクラフトが使用されたり、機械学習の勉強にも使用されています。<br>' +
        '私たちのミッションは、この素晴らしいゲームを遊ぶ人たちを増やし、正しく優良な情報を提供する場を作ることで、社会貢献を行うことです。'
      },
      top: {
        title: 'Minecraft <small>doujin club</small>',
        circle_name: 'Hoge.class',
        whats_doujin: 'What\'s minecraft "doujin"?'
      }
    },
    ja: {
      menu: {
        top: 'トップ',
        overview: '概要',
        members: 'メンバー',
        contact: 'お問合せ'
      },
      footer: {
        name: 'ほげ.class ミッション',
        mission: '私たちはマインクラフトが大好きです。そして、このゲームをもっと多くの方々に楽しんでもらいたいと思っています。<br>' +
        'マインクラフトはただ遊ぶだけではなく、マイクラファンが開発する拡張機能を使えばプログラミングによって、自由に遊びを創造することができます。' +
        '多人数で遊びたいと思い、まともマルチサーバを建てると、ネットワークの知識を得ることができます。<br>' +
        '今日、子供のIT教育にもマインクラフトが使用されたり、機械学習の勉強にも使用されています。<br>' +
        '私たちのミッションは、この素晴らしいゲームを遊ぶ人たちを増やし、正しく優良な情報を提供する場を作ることで、社会貢献を行うことです。'
      },
      top: {
        title: 'Minecraft <small>同人サークル</small>',
        circle_name: 'ほげ.class',
        whats_doujin: 'マイクラ同人とは？'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/resources/Translation.js